import React, { useEffect, useState } from "react";
import "./delayMarkedPopup.scss";
import { Dialog, Divider, withStyles } from "@material-ui/core";
import close_icon from "../../../../../assets/crossIcon.svg";
import calendar_icon from "../../../../../assets/calendar_blue.svg";
import left_arrow from "../../../../../assets/left_arrow.svg";
import TitleSubtitleCard from "../../../../common/Modules/TitleSubtitleCard";
import moment from "moment";
import { Calendar } from "react-calendar";
import dateFormat from "dateformat";
import {
  GET_DELAY_MARKED_CALENDAR_DATA,
  GET_DELAY_MARKED_DATA,
} from "./DelayMarkedApiHandler/apiConstant";
import Loader from "../../../../UI Component/Loader/Loader";
import { c2cPostApiHandler } from "../../../../../Util/c2cApiHandler";

const styles = {
  dialogPaper: {
    width: "420px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
    position: "inherit",
    overflowY: "visible",
  },
};

const DelayMarkedPopup = (props) => {
  const { classes, openDelayMarkedPopup, scheduleId, handleClosePopup } = props;

  const [delayMarkedDetails, setDelayMarkedDetails] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [availableDates, setAvailableDates] = useState([]);
  const [loader, setLoader] = useState(false);

  // Lifecycle Methods ===>

  useEffect(() => {
    getDelayMarkedDetails();
  }, []);

  // <===

  // API Calls ===>

  const getDelayMarkedDetails = () => {
    let payload = {
      schedule_id: scheduleId,
    };
    setLoader(true);
    let resData = c2cPostApiHandler(GET_DELAY_MARKED_DATA, payload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res?.data?.statusCode === 200) {
          setDelayMarkedDetails(res.data);
          setSelectedDate(res.data.date);
          getDelayMarkedCalendarDetails(res.data.date);
        } else {
          setDelayMarkedDetails({});
        }
      } else {
        setDelayMarkedDetails({});
      }
    });
  };

  const getDelayMarkedCalendarDetails = (value) => {
    let date = new Date(value);
    let firstDay = dateFormat(
      new Date(date.getFullYear(), date.getMonth(), 1),
      "yyyy-mm-dd"
    );
    let lastDay = dateFormat(
      new Date(date.getFullYear(), date.getMonth() + 1, 0),
      "yyyy-mm-dd"
    );

    let payload = {
      schedule_id: scheduleId,
      start_date: firstDay,
      end_date: lastDay,
    };
    let resData = c2cPostApiHandler(GET_DELAY_MARKED_CALENDAR_DATA, payload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res?.data?.statusCode === 200) {
          setAvailableDates(res.data.schedules);
        } else {
          setAvailableDates([]);
        }
      } else {
        setAvailableDates([]);
      }
    });
  };

  // <===

  // Actions ===>

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const handleDateSelection = (val) => {
    setSelectedDate(dateFormat(new Date(val), "yyyy-mm-dd"));
    let data = availableDates.filter(
      (dt) => dt.date === dateFormat(new Date(val), "yyyy-mm-dd")
    );
    setDelayMarkedDetails(data[0]);
    setShowCalendar(false);
  };

  // <===

  // Display UI ===>

  const displayDelayMarkedPopup = () => {
    return (
      <Dialog
        open={openDelayMarkedPopup}
        classes={{ paper: classes.dialogPaper }}
      >
        {displayDelayMarkedContent()}
      </Dialog>
    );
  };

  const displayDelayMarkedContent = () => {
    return (
      <div className="delay-marked-content">
        <div
          className="delay-marked-content-header"
          style={{ paddingLeft: window.innerWidth > 767 ? "" : "0" }}
        >
          <div
            className="delay-marked-content-header-value"
            style={{ fontSize: window.innerWidth > 767 ? "" : "15px" }}
          >
            {window.innerWidth < 767 && (
              <img
                src={left_arrow}
                alt=""
                style={{ marginRight: "9.5px", transform: "rotate(180deg)" }}
                onClick={handleClosePopup}
              />
            )}{" "}
            Delay Marked for
          </div>
          {window.innerWidth > 767 && (
            <div
              className="delay-marked-content-header-close"
              onClick={handleClosePopup}
            >
              {"Close"} <img src={close_icon} alt="" />
            </div>
          )}
        </div>
        {window.innerWidth > 767 && <Divider />}
        <div className="delay-marked-content-body">
          <div
            className="d-flex ai-center"
            style={{ marginBottom: window.innerWidth > 767 ? "18px" : "30px" }}
          >
            <div style={{ flex: "1" }}>
              <TitleSubtitleCard
                title="Date"
                subtitle={
                  delayMarkedDetails?.date
                    ? moment(delayMarkedDetails?.date).format("DD MMMM YYYY")
                    : ""
                }
              />
            </div>
            <div style={{ position: "relative" }}>
              <img
                src={calendar_icon}
                alt=""
                style={{ width: "24px", height: "22px", cursor: "pointer" }}
                onClick={toggleCalendar}
              />
              {showCalendar && (
                <div className="delay-marked-calendar">
                  <Calendar
                    onChange={handleDateSelection}
                    value={selectedDate ? new Date(selectedDate) : ""}
                    showNeighboringMonth={false}
                    tileDisabled={({ date }) => {
                      let av = availableDates.filter(
                        (dt) => dt.date === dateFormat(date, "yyyy-mm-dd")
                      );
                      return av?.length === 0;
                    }}
                    onActiveStartDateChange={({ activeStartDate }) => {
                      setLoader(true);
                      getDelayMarkedCalendarDetails(
                        dateFormat(new Date(activeStartDate), "yyyy-mm-dd")
                      );
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="row pl-0 pr-0">
            <div className="col-6">
              <TitleSubtitleCard
                title="Slot Start Time"
                subtitle={
                  delayMarkedDetails?.start_time
                    ? moment(delayMarkedDetails?.start_time, "hh:mm").format(
                        "hh : mm A"
                      )
                    : ""
                }
              />
            </div>
            <div className="col-6">
              <TitleSubtitleCard
                title="Slot End Time"
                subtitle={
                  delayMarkedDetails?.end_time
                    ? moment(delayMarkedDetails?.end_time, "hh:mm").format(
                        "hh : mm A"
                      )
                    : ""
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  // <===

  return (
    <>
      {loader && <Loader />}
      {window.innerWidth > 767
        ? displayDelayMarkedPopup()
        : displayDelayMarkedContent()}
    </>
  );
};

export default withStyles(styles)(DelayMarkedPopup);
